import { Sidebar } from 'common/components/sidebar/Sidebar.tsx'
import { menuTabs } from '@/components/sidebar/sidebarTabsAdmin.tsx'

export const SidebarAdmin = (props: any) => <Sidebar {...props} mode={props.mode} menuTabs={menuTabs} admin />